import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Divider,
} from '@mui/material';
import { IoLanguageOutline } from 'react-icons/io5';
import { PiUserCircleThin } from 'react-icons/pi';
//import SettingsIcon from '@mui/icons-material/Settings';
import PatternIcon from '@mui/icons-material/Pattern';
//import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import LogoutIcon from '@mui/icons-material/Logout';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './../App.css';

const Header = ({ sidebarExpanded, toggleSidebar, setIsAuthenticated }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const [languageAnchorEl, setLanguageAnchorEl] = useState(null);
  const [userMenuAnchorEl, setUserMenuAnchorEl] = useState(null);
  const [userName, setUserName] = useState('');
  const [userId, setUserId] = useState('');

  useEffect(() => {
    const storedUserName = localStorage.getItem('userName');
    const storedUserId = localStorage.getItem('userId');
    if (storedUserName && storedUserId) {
      setUserName(storedUserName);
      setUserId(storedUserId);
    }
  }, []);

  const handleLanguageClick = (event) => {
    setLanguageAnchorEl(event.currentTarget);
  };

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    setLanguageAnchorEl(null);
    document.body.dir = lang === 'ar' ? 'rtl' : 'ltr';
  };

  const handleUserMenuClick = (event) => {
    setUserMenuAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setUserMenuAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userName');
    localStorage.removeItem('userId');
    localStorage.removeItem('userRole');
    localStorage.removeItem('role_id');
    localStorage.removeItem('owner_id');
    localStorage.removeItem('permissions');
    localStorage.removeItem('me_menu');
    setIsAuthenticated(false);

    navigate('/login');
  };

  return (
    <Box
      className="header-container"
      sx={{
        backgroundColor: '#1a468d', // أزرق ملكي حسب الهوية
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 2,
        direction: i18n.language === 'ar' ? 'rtl' : 'ltr', // اجعل الاتجاه صحيح حسب اللغة
        minHeight: '56px',
      }}
    >
      <Typography variant="h6">{/*Smart Stable*/}</Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconButton onClick={handleLanguageClick}>
          <IoLanguageOutline />
        </IconButton>
        <Menu
          anchorEl={languageAnchorEl}
          open={Boolean(languageAnchorEl)}
          onClose={() => setLanguageAnchorEl(null)}
        >
          <MenuItem onClick={() => handleLanguageChange('en')}>EN</MenuItem>
          <MenuItem onClick={() => handleLanguageChange('ar')}>AR</MenuItem>
          <MenuItem onClick={() => handleLanguageChange('pt')}>PT</MenuItem>
        </Menu>

        <IconButton onClick={handleUserMenuClick}>
          <PiUserCircleThin size={28} />
        </IconButton>
        <Menu
          anchorEl={userMenuAnchorEl}
          open={Boolean(userMenuAnchorEl)}
          onClose={handleUserMenuClose}
          PaperProps={{ elevation: 4, sx: { borderRadius: 2, p: 1 } }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            px={2}
            py={1}
            textAlign="center"
          >
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              textTransform="uppercase"
            >
              {userName}
            </Typography>
            <Typography variant="body2">{userId}</Typography>
          </Box>

          <Divider sx={{ my: 1 }} />

          <MenuItem
            onClick={() => {
              navigate('/ChangePassword');
              handleUserMenuClose();
            }}
          >
            <PatternIcon fontSize="small" style={{ marginRight: 8 }} />
            {t('Change_password')}
          </MenuItem>
          {/*}
          <MenuItem
            onClick={() => {
              navigate('/settings');
              handleUserMenuClose();
            }}
          >
            <SettingsIcon fontSize="small" sx={{ mr: 1 }} />
            {t('Settings')}
          </MenuItem>
          <MenuItem
            onClick={() => {
              navigate('/faq');
              handleUserMenuClose();
            }}
          >
            <HelpOutlineIcon fontSize="small" sx={{ mr: 1 }} />
            {t('FAQ')}
          </MenuItem>
*/}
          <Divider sx={{ my: 1 }} />
          <Box px={2} py={1}>
            <Button
              fullWidth
              variant="contained"
              color="error"
              startIcon={<LogoutIcon />}
              onClick={() => {
                handleLogout();
                handleUserMenuClose();
              }}
              sx={{ typography: 'body1' }}
            >
              {t('logout')}
            </Button>
          </Box>
        </Menu>
      </Box>
    </Box>
  );
};

export default Header;
